/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import {
  ApprovalState,
  InspectionState,
  SignatureState,
  User,
  commentsLogService,
  ActForm,
} from '@builddocs/data-management'
import {
  AOSRType,
  inspectAct,
  inspectSecondaryAct,
  SecondaryActType,
  signAct,
  signSecondaryAct,
} from '@builddocs/filestore-api'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'

type DeviateArgs =
  | {
      act: AOSRType | SecondaryActType
      user: User
      contractId: string
      body: any
      additionalInfo: any
      onSuccess: () => void
      query: any
      refreshActs?: () => void
      refreshComments?: () => void
      faceControl?: unknown
      action: 'inspection'
      actType: keyof typeof ActForm
      withPoa?: boolean
      poaId?: string | null
      poaDateStart?: string | null
      poaDateEnd?: string | null
    }
  | {
      act: AOSRType | SecondaryActType
      user: User
      contractId: string
      body: any
      additionalInfo: any
      onSuccess: () => void
      query: any
      refreshActs?: () => void
      refreshComments?: () => void
      faceControl: any
      action: 'signing'
      actType: keyof typeof ActForm
      withPoa?: boolean
      poaId?: string | null
      poaDateStart?: string | null
      poaDateEnd?: string | null
    }

export const handleDeviate = async (args: DeviateArgs) => {
  const {
    act,
    contractId,
    body,
    user,
    additionalInfo,
    onSuccess,
    query,
    refreshActs,
    actType,
    refreshComments,
    withPoa,
    poaId,
    poaDateStart,
    poaDateEnd,
  } = args

  try {
    if (args.action === 'signing') {
      if (actType === ActForm.AOSR) {
        await signAct({
          documentId: act.id,
          employmentId: user.employment.employmentId,
          signatureState: SignatureState.REJECTED,
          withPoa,
          poaId,
          poaDateStart,
          poaDateEnd,
        })
      } else {
        await signSecondaryAct({
          comment: body.problemDescription,
          documentId: act.id,
          employmentId: user.employment.employmentId,
          signatureState: SignatureState.REJECTED,
          withPoa,
          poaId,
          poaDateStart,
          poaDateEnd,
        })
      }
      await commentsLogService.create(
        contractId,
        {
          ...body,
          externalEntityId: act.id,
          externalEntityInfo: act.actType,
          entityId: additionalInfo.contractId,
          entityType: 'ACT_DOC',
        },
        query,
      )
      toast.info(
        `Сделана запись в журнал замечаний для ${
          act.closingName ?? act.name ?? 'акта'
        }`,
      )
      onSuccess()

      refreshActs && refreshActs()
    } else {
      if (
        act.approvalStatus === ApprovalState.APPROVAL ||
        act.approvalStatus === ApprovalState.REJECTED
      ) {
        if (actType === ActForm.AOSR) {
          await inspectAct(
            act.id,
            user.employment.employmentId,
            InspectionState.REJECTED,
          )
        } else {
          await inspectSecondaryAct(
            act.id,
            user.employment.employmentId,
            InspectionState.REJECTED,
          )
        }
      }
      await commentsLogService.create(
        contractId,
        {
          ...body,
          externalEntityId: act.id,
          externalEntityInfo: act.actType,
          entityId: additionalInfo.contractId,
          entityType: 'ACT_DOC',
          problemDescription: body.problemDescription,
        },
        query,
      )
      refreshActs && refreshActs()
      refreshComments && refreshComments()
      toast.info(`Сделана запись в журнал замечаний`)
      onSuccess()
    }
  } catch (err) {
    const e = err as AxiosError

    if (
      e.response?.data?.statusCode === 120317 &&
      body.problemDescription.length
    ) {
      await commentsLogService.create(
        contractId,
        {
          ...body,
          externalEntityId: act.id,
          externalEntityInfo: act.actType,
          entityId: additionalInfo.contractId,
          entityType: 'ACT_DOC',
          problemDescription: body.problemDescription,
        },
        query,
      )
      onSuccess()
    } else
      toast.error(e.response?.data?.message ?? 'Не удалось отклонить запись')
  }
}
